/*jshint esversion: 6 */

const readMoreLessBtns = document.querySelector('.read-more-less-toggle');

if ( readMoreLessBtns ) { // Only continue if buttons exist

	var textContent = '';
	if ( document.body.classList.contains('tax-product_cat') ) { // Product category
		textContent = document.querySelector('.term-description');
	} else if ( document.body.classList.contains('single-product') ) { // Single product short description
		textContent = document.querySelector('.woocommerce-product-details__short-description');
	}/*  else { // Add functionality other places
		textContent = readMoreLessBtns.previousSibling;
		// Maybe check if class name includes 'description'.
	} */

	if ( textContent ) {

		const buttonContainer = document.querySelector('.read-more-less-toggle');
		const readMoreButton = document.querySelector('#read-more-button');
		const readLessButton = document.querySelector('#read-less-button');
		const MIN_DESCRIPTION_HEIGHT_TOGGLE = 60;

		const termFirstPara = textContent.querySelector('p');
		let parentPos = textContent.getBoundingClientRect();
		let parentHeight = textContent.scrollHeight;
		let childPos = termFirstPara.getBoundingClientRect();
		let relativPosBottom = childPos.bottom - parentPos.top;

		window.addEventListener('resize', () => {
			parentPos = textContent.getBoundingClientRect();
			parentHeight = textContent.scrollHeight;
			childPos = termFirstPara.getBoundingClientRect();
			relativPosBottom = childPos.bottom - parentPos.top;
		});

		if ( parentHeight == relativPosBottom || parentHeight < relativPosBottom || Math.abs(parentHeight - relativPosBottom) < MIN_DESCRIPTION_HEIGHT_TOGGLE ) {
			buttonContainer.remove();
		} else {
			setHeight(textContent, relativPosBottom);
			buttonContainer.style.display = 'block';
			showButton(readMoreButton);
			hideButton(readLessButton);
		}

		readMoreButton.addEventListener('click', () => {
			setHeight(textContent, parentHeight);
			hideButton(readMoreButton);
			showButton(readLessButton);
		});

		readLessButton.addEventListener('click', () => {
			setHeight(textContent, relativPosBottom);
			hideButton(readLessButton);
			showButton(readMoreButton);
		});

	}

	function setHeight(elem, newHeight) {
		elem.style.maxHeight = newHeight + 'px';
	}

	function hideButton(button) {
		button.style.display = 'none';
	}

	function showButton(button) {
		button.style.display = 'inline-block';
	}

}
